import React from 'react'

const Counter = ({setAmount, amount}) => (
  <div className='counter'>
    <button onClick={_ => setAmount(a => a <= 1 ? a : a - 1)}>-</button>
    <input type='number' onChange={e => setAmount(parseInt(e.target.value))} value={amount}/>
    <button onClick={_ => setAmount(a => a + 1)}>+</button>
  </div>
)

export default Counter
